import React, { useEffect, useState } from 'react';
import { GetEmrDocumentSummuryList } from 'Routes/Protected/PatientsForVisit/adapters/GetEmrDocumentSummuryList';

const useGetSummaryList = () => {
  const [documentSummaryList, setDocumentSummaryList] =
    useState();
  useEffect(() => {
    GetEmrDocumentSummuryList(setDocumentSummaryList);
  }, []);

  return documentSummaryList;
};

export default useGetSummaryList;
